module.exports = __webpack_public_path__ + "img/za.2fdc7d0e.svg";